<div class="mat-elevation-z2">
    <div class="button-wrapper p-20 pb-16" *ngIf="showAddButton">
        <!-- Add button -->
        <button mat-raised-button color="accent" type="button" (click)="emitRowAction({ action: 'add' })">
            <span>Aggiungi</span>
            <mat-icon class="material-icons ml-8">add</mat-icon>
        </button>
    </div>

    <!-- Table -->
    <table mat-table class="w-100-p" [dataSource]="tableDataSource">
        <ng-container *ngFor="let editColumn of editColumns" [matColumnDef]="editColumn.nomeColonna">
            <!-- Header data -->
            <th [style.text-align]="editColumn.alignment === 'center' ? 'center' : 'left'" mat-header-cell *matHeaderCellDef>
                {{ editColumn.nomeColonna }}
            </th>
            <!-- Column data -->
            <td [style.text-align]="editColumn.alignment === 'center' ? 'center' : 'left'" mat-cell *matCellDef="let element">
                <ng-container
                    *ngIf="
                        editColumn.dataType !== 'date' && editColumn.idColonna !== 'predefinitoFatture' && editColumn.idColonna !== 'predefinitoCorrispettivi'
                    ">
                    {{ element[editColumn.idColonna] }}
                </ng-container>

                <ng-container *ngIf="editColumn.dataType === 'date'">
                    {{ element[editColumn.idColonna] | date : 'shortDate' }}
                </ng-container>

                <ng-container *ngIf="editColumn.idColonna === 'predefinitoFatture'">
                    <div *ngIf="!element.predefinitoFatture; else predefinito">
                        <button (click)="emitRowAction({ action: editColumn.idColonna, element: element })" mat-button color="accent" type="button">
                            Rendi predefinito
                        </button>
                    </div>
                </ng-container>

                <ng-container *ngIf="editColumn.idColonna === 'predefinitoCorrispettivi'">
                    <div *ngIf="!element.predefinitoCorrispettivi; else predefinito">
                        <button (click)="emitRowAction({ action: editColumn.idColonna, element: element })" mat-button color="accent" type="button">
                            Rendi predefinito
                        </button>
                    </div>
                </ng-container>

                <ng-container *ngIf="editColumn.idColonna === 'actions'">
                    <ng-container *ngFor="let rowActionIcon of rowActionIcons">
                        <ng-container *ngIf="element.predefinitoCorrispettivi || element.predefinitoFatture; else showClassicActions">
                            <!-- Perche gli ateco predefeniti non possono essere eliminati -->
                            <ng-container *ngIf="rowActionIcon === 'delete'; else showClassicActions">
                                <span matTooltip="Ateco predefinito non eliminabile" matTooltipPosition="above" [matTooltipDisabled]="!isButtonDisabled(true)">
                                    <button [disabled]="deleteButtonIsDisabled" mat-icon-button>
                                        <mat-icon>{{ rowActionIcon }}</mat-icon>
                                    </button>
                                </span>
                            </ng-container>
                        </ng-container>

                        <ng-template #showClassicActions>
                            <button [id]="rowActionIcon" (click)="emitRowAction({ action: rowActionIcon, element: element })" mat-icon-button>
                                <mat-icon>{{ rowActionIcon }}</mat-icon>
                            </button>
                        </ng-template>
                    </ng-container>
                </ng-container>

                <ng-template #predefinito>
                    <mat-icon class="forfettapp-color">check_circle</mat-icon>
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>
